// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Ug12d7f-oWEQcD {\n  padding: 8px 4px 4px;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n.Ug12d7f-oWEQcD hr {\n  margin: 16px 0;\n}\n.Ug12d7f-oWEQcD .MjdPbNkZrX5kS5 {\n  color: #5e6c84;\n  margin-left: 4px;\n}\n.Ug12d7f-oWEQcD ._29jT4K3iFtPk7m {\n  margin-bottom: 3px;\n}\n.Ug12d7f-oWEQcD ._3toy5KAOuEq1Jp {\n  color: #5e6c84;\n}\n.Ug12d7f-oWEQcD ._3toy5KAOuEq1Jp:hover {\n  color: #172b4d;\n}\n.Ug12d7f-oWEQcD .L8_3Ejc4KhDijU {\n  background-color: #F7F0FA;\n  margin-bottom: 8px;\n  min-height: 123px;\n  padding-top: 16px;\n}\n.Ug12d7f-oWEQcD .L8_3Ejc4KhDijU img {\n  width: 190px;\n  margin-bottom: -20px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popoverContent": "Ug12d7f-oWEQcD",
	"visibilityText": "MjdPbNkZrX5kS5",
	"visibilityIcon": "_29jT4K3iFtPk7m",
	"learnMoreLink": "_3toy5KAOuEq1Jp",
	"imgContainer": "L8_3Ejc4KhDijU"
};
export default ___CSS_LOADER_EXPORT___;
